import * as Data from './archibus-v2/DataApi'
import * as Security from './archibus/SecurityApi'
import {processLicenses} from './util/config'

export const fetchAppParameters = () => {
  let config = {}
  return Data.getDataFromDataSource('ab-self-service.axvw', 'appparams')
    .then(({data}) => {
      config = data.reduce((acc, curVal) => {
        const {paramId, paramValueFormat} = curVal
        acc[paramId] = paramValueFormat
        return acc
      }, {})

      return Security.getLicenseInfo()
    })
    .then(licenseInfo => {
      const availableLicense = processLicenses(licenseInfo)
      const payload = {...config, ...availableLicense}
      return Promise.resolve(payload)
    })
}
